import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "../styles.css";
import logo from "../logo.jpg";

const Navbar = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleRegisterClick = () => {
    navigate("/registration");
  };

  return (
    <div>
      <nav
        className="navbar is-fixed-top has-shadow"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="heading">
          <NavLink className="navbar-item">
            <img src={logo} className="navbar-logo" alt="Logo" />
          </NavLink>
        </div>

        <div className="navbar-end">
          {!user && (
            <>
              <div className="navbar-item">
                <button className="button is-primary" onClick={handleRegisterClick}>
                  Register Here
                </button>
              </div>
              <div className="navbar-item">
                <button className="button is-primary" onClick={handleLoginClick}>
                  Sign In
                </button>
              </div>
            </>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
